import React, {useState, useEffect} from 'react'  
import { useTranslation } from 'react-i18next'; 

const LangSwitcher = () => {  
    const [t, i18n] = useTranslation('common'); 
    const [lang , setLang] = useState('')

    useEffect(()=>{  
        if(!localStorage.getItem("appLang")){
            localStorage.setItem('appLang', 'de');
            setLang('de')
        } 
        i18n.changeLanguage(localStorage.getItem("appLang")) 
        setLang(localStorage.getItem("appLang"))
    },[lang]) 



    function langChange(l){
        let selected = ''
        if(l === 'en'){
            setLang(l) 
            localStorage.setItem('appLang', l); 
        }else if(l === 'de'){
            setLang(l) 
            localStorage.setItem('appLang', l);
        }else if(l === 'it'){
            setLang(l) 
            localStorage.setItem('appLang', l);
        } 
    }
    return (
        <div className='lang-switch'>
            <span>{t('app.lang')} </span>
            <button className={`lang ${lang == 'de' ? "active" : ""}`} onClick={() => langChange('de')}>DE</button>
            <span>|</span>
            <button className={`lang ${lang == 'en' ? "active" : ""}`} onClick={() => langChange('en')}>EN</button>
            <span>|</span>
            <button className={`lang ${lang == 'it' ? "active" : ""}`} onClick={() => langChange('it')}>IT</button> 
        </div>
    )
}

export default LangSwitcher